let __flarum_default_export__;
import app from 'flarum/forum/app';
export default __flarum_default_export__ = () => 'flarum-subscriptions' in flarum.extensions && m.route.get().includes(app.route('following'));
flarum.reg.add('fof-follow-tags', 'forum/utils/isFollowingPage', __flarum_default_export__);